import { SizeReportRequest } from '../schemas/sizeReportRequest';
import { SizeReportResponseItem } from '../schemas/sizeReportResponseRow';
import { StageMapRequest } from '../schemas/stageMapRequest';
import { StageMapResponseRow } from '../schemas/stageMapResponse';
import { StageReportRequest } from '../schemas/stageReportRequest';
import { StageReportResponseItem } from '../schemas/stageReportResponse';
import { wranglerSlice } from '../wranglerSlice';

const blueberryDataEndpoints = wranglerSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStageReport: builder.query<
      StageReportResponseItem[],
      StageReportRequest
    >({
      query: (body: StageReportRequest) => {
        return {
          url: '/v1/blueberry/stage/report',
          method: 'POST',
          body,
        };
      },
    }),
    getSizeReport: builder.query<SizeReportResponseItem[], SizeReportRequest>({
      query: (body: SizeReportRequest) => {
        return {
          url: '/v1/blueberry/size/report',
          method: 'POST',
          body,
        };
      },
    }),
    getStageMap: builder.query<StageMapResponseRow[], StageMapRequest>({
      query: (body: StageMapRequest) => {
        return {
          url: '/v1/blueberry/stage/map',
          method: 'POST',
          body,
        };
      },
    }),
  }),
});

export const {
  useGetStageReportQuery,
  useGetSizeReportQuery,
  useGetStageMapQuery,
} = blueberryDataEndpoints;
